import { BiTransfer } from 'react-icons/bi';
// import { BsGrid3X3Gap } from 'react-icons/bs';
import { MdWifiCalling3 } from 'react-icons/md';
import buildingIcon from '../../../src/assets/images/building.png';

import classes from './PropertyCard.module.css';
// import { GoMail } from 'react-icons/go';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { FaCrown } from 'react-icons/fa';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { IoIosMail, IoLogoWhatsapp } from 'react-icons/io';
import { TiStarFullOutline } from 'react-icons/ti';
import { useDispatch, useSelector } from 'react-redux';
import {
  //  Link,
  useNavigate
} from 'react-router-dom';
import { toast } from 'react-toastify';
import bathIcon from '../../../src/assets/images/bath.png';
import fullScreen from '../../../src/assets/images/fullScreen.png';
import sofa from '../../../src/assets/images/sofa.png';
import upGrid from '../../../src/assets/images/upGrid.png';
import { imageUrl } from '../../config/apiUrl';
import { propertiesData } from '../../constant/commonData';
import { mapPin } from '../../constant/imagePath';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import { useFavoriteEntityMutation, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { updateUser } from '../../store/auth/authSlice';
import { m2ToFt2, usdToOther } from '../../utils/helpers';
import ElasticCarousel from '../ElasticCarousel';
import Tooltip from '../Tooltip';
/*eslint-disable*/

const PropertyCard = ({
  data = propertiesData[0],
  onEmailClick = () => null,
  type = 'iconWithImage',
  refetch,
  outerNavigate
}) => {
  const { t } = useTranslation('webCommon');
  const { isLogin, user } = useSelector((state) => state.authReducer);
  const [postApiFunc] = usePostApiMutation();

  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { areaUnit, currency } = useSelector((state) => state.converterReducer);

  const feature = data?.isPremium || data?.isFeatured;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [isFavorite, setIsFavorite] = useState(data?.favoriteBy?.includes(user?._id));
  const [onFavorite, { isLoading: isFavoriting }] = useFavoriteEntityMutation();

  const isFavorite = data?.favoriteBy?.includes(user?._id);

  const handleCompare = async (data) => {
    const onlyCompareProperty = user?.compareList?.filter((item) => item?.type == 'Property');
    const ifAlreadyExist = onlyCompareProperty?.find((item) => item?.entity == data?._id);
    if (!ifAlreadyExist && onlyCompareProperty?.length >= 3)
      return toast.error(t('propertyCard.toast.error'));

    const response = await postApiFunc({
      url: `users/compare/add`,
      method: 'POST',
      tag: `compareListFront`,
      data: {
        id: data?._id,
        type: 'property'
      }
    });
    if (response?.data) {
      dispatch(updateUser(response?.data?.data));
      toast.success(
        `${t('propertyCard.property')} ${
          ifAlreadyExist ? t('propertyCard.toast.removedFrom') : t('propertyCard.toast.addedIn')
        } ${t('propertyCard.toast.success')}`
      );
    }
  };

  const handleFavorite = async () => {
    if (isFavoriting) return;
    const res = await onFavorite({ id: data?._id, type: 'property' });
    // refetch && refetch();
    if (res?.data) {
      if (res?.data?.data) {
        toast.success(t('propertyCard.toast.propertyRemoved'));
      } else {
        toast.success(t('propertyCard.toast.propertyAdded'));
      }
    }
  };

  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };

  return (
    <>
      <style>
        {`
          a {
            text-decoration: none;
            color: inherit;
          }
          a:hover {
            text-decoration: none;
            color: inherit;
          }
      `}
      </style>

      <div className={type === 'map' ? classes.cardMainMap : classes.cardMain}>
        <div className={type !== 'map' && classes.paddingDiv}>
          <div className={classes.image}>
            <ElasticCarousel
              {...(!outerNavigate && { navigateLink: `/property/${data?.slug ?? '1'}` })}
              images={data?.images ?? []}
              customRightArrow={<FiChevronRight size={26} color="#fff" />}
              customLeftArrow={<FiChevronLeft size={26} color="#fff" />}
              customArrows={true}
            />
            {!feature ? (
              <div className={classes.socialIconsWrap}>
                {/* <Tooltip text={t('propertyCard.tooltips.call')}>
                <div className={classes.socialIcons}>
                  <MdWifiCalling3 fill="#E2831B" size={20} />
                </div>
              </Tooltip> */}
                {/* <Tooltip text={t('propertyCard.tooltips.email')}>
                <div
                  className={classes.socialIcons}
                  onClick={(e) => {
                    e?.stopPropagation();
                    onEmailClick && onEmailClick();
                  }}>
                  <IoIosMail fill="#E2831B" size={20} />
                </div>
              </Tooltip> */}
              </div>
            ) : (
              <>
                <div className={classes?.featuredPremiumContainer}>
                  <span
                    className={`${
                      (data?.isFeatured && classes?.featuredIco) ||
                      (data?.isPremium && classes?.premiumIco)
                    }`}>
                    {data?.isFeatured && <TiStarFullOutline size={16} />}
                    {data?.isPremium && <FaCrown size={14} />}
                    {(data?.isPremium && t('projectCard.premium')) ||
                      (data?.isFeatured && t('projectCard.featured'))}
                  </span>
                </div>
              </>
              // <div className={classes.featureTag}>{t('propertyCard.featured')}</div>
            )}

            {type !== 'map' && (
              <div className={classes.iconWrap}>
                <Tooltip text={t('propertyCard.tooltips.compare')}>
                  <div className={classes.iconWrapInner}>
                    <BiTransfer
                      onClick={(e) => {
                        e.preventDefault();
                        e?.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        if (!handleAction()) return;
                        handleCompare(data);
                      }}
                      size={30}
                      fill={`${
                        user?.compareList?.find((item) => item?.entity == data?._id)
                          ? 'var(--action-icon-clr)'
                          : 'var(--white-clr)'
                      } `}
                    />
                  </div>
                </Tooltip>
                <Tooltip
                  text={
                    isFavorite
                      ? t('propertyCard.tooltips.removeFavorite')
                      : t('propertyCard.tooltips.addFavorite')
                  }>
                  {isFavorite ? (
                    <div className={classes.iconWrapInner}>
                      <AiFillHeart
                        onClick={(e) => {
                          e.preventDefault();
                          e?.stopPropagation();
                          e.nativeEvent.stopImmediatePropagation();
                          handleFavorite();
                        }}
                        fill="var(--action-icon-clr)"
                        size={25}
                      />
                    </div>
                  ) : (
                    <div className={classes.iconWrapInner}>
                      <AiOutlineHeart
                        onClick={(e) => {
                          e.preventDefault();
                          e?.stopPropagation();
                          e.nativeEvent.stopImmediatePropagation();
                          if (!handleAction()) return;
                          handleFavorite();
                        }}
                        fill="var(--white-clr)"
                        size={25}
                      />
                    </div>
                  )}
                </Tooltip>
              </div>
            )}
          </div>
        </div>

        {/* <Link to={`/property/${data?.slug ?? '1'}`}> */}
        <div>
          <div
            className={classes.contentWrap}
            onClick={(e) => {
              outerNavigate ? outerNavigate() : navigate(`/property/${data?.slug ?? '1'}`);
            }}>
            <div className={type === 'map' ? classes.contentMap : classes.content}>
              {type === 'map' && (
                <div className={[classes.mapPriceRows, classes.priceRows].join(' ')}>
                  <div className={classes.price}>
                    <p>{usdToOther({ amount: data?.price, ...currency })}</p>
                    <p>
                      {data?.propertyPurpose?.en == 'Rent'
                        ? data?.rentType?.[selectedLanguage]
                        : ''}
                    </p>
                  </div>
                  {/* {type === 'map' && (
                    <div
                      className={classes?.companyLogos}
                      onClick={(e) => {
                        e.preventDefault();
                        e?.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();

                        navigate(`/company/${data?.company?.slug}`);
                      }}>
                      <img src={imageUrl(data?.company?.photo)} />
                    </div>
                  )} */}
                  {type === 'map' && (
                    <div className={[classes.mapIconWrapper, classes.iconWrap].join(' ')}>
                      <Tooltip text={t('propertyCard.tooltips.compare')}>
                        <div className={classes.iconWrapInner}>
                          <BiTransfer
                            onClick={(e) => {
                              e.preventDefault();
                              e?.stopPropagation();
                              e.nativeEvent.stopImmediatePropagation();
                              if (!handleAction()) return;
                              handleCompare(data);
                            }}
                            size={30}
                            fill={`${
                              user?.compareList?.find((item) => item?.entity == data?._id)
                                ? 'var(--action-icon-clr)'
                                : 'var(--white-clr)'
                            } `}
                          />
                        </div>
                      </Tooltip>
                      <Tooltip
                        text={
                          isFavorite
                            ? t('propertyCard.tooltips.removeFavorite')
                            : t('propertyCard.tooltips.addFavorite')
                        }>
                        {isFavorite ? (
                          <div className={classes.iconWrapInner}>
                            <AiFillHeart
                              onClick={(e) => {
                                e.preventDefault();
                                e?.stopPropagation();
                                e.nativeEvent.stopImmediatePropagation();
                                handleFavorite();
                              }}
                              fill="var(--action-icon-clr)"
                              size={25}
                            />
                          </div>
                        ) : (
                          <div className={classes.iconWrapInner}>
                            <AiOutlineHeart
                              onClick={(e) => {
                                e.preventDefault();
                                e?.stopPropagation();
                                e.nativeEvent.stopImmediatePropagation();
                                if (!handleAction()) return;
                                handleFavorite();
                              }}
                              fill="var(--white-clr)"
                              size={25}
                            />
                          </div>
                        )}
                      </Tooltip>
                    </div>
                  )}
                </div>
              )}
              <div className={classes.description}>
                <p>{data?.title?.[selectedLanguage]}</p>
                {type === 'map' && (
                  <div
                    className={classes?.companyLogos}
                    onClick={(e) => {
                      e.preventDefault();
                      e?.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();

                      navigate(`/company/${data?.company?.slug}`);
                    }}>
                    <img src={imageUrl(data?.company?.photo)} />
                  </div>
                )}
              </div>
              <div className={classes.addressWrap}>
                <img src={mapPin} alt="location" className={classes.locationIcon} />
                <p className="maxLine1">{data?.address}</p>
              </div>

              <div className={classes.propertyDetailWrap}>
                <Row className={classes.gap}>
                  <Col lg={6} md={6} xl={6} className={classes.propertyDetail}>
                    {/* <RiHotelFill color="var(--text-dark-gray-clr)" /> */}
                    {/* <p>{data?.propertyType}</p> */}
                    {/* <IconList
                      className={classes.infoIcons}
                      Icon={RiHotelFill}
                      value={data?.propertyType?.title?.[selectedLanguage]}
                      label={t('propertyCard.tooltips.propertyType')}
                    /> */}
                    <Tooltip text={t('propertyCard.tooltips.propertyType')}>
                      <div className={classes.iconContainer}>
                        <img src={buildingIcon} alt="buildingIcon" />

                        <p>{data?.propertyType?.title?.[selectedLanguage]}</p>
                      </div>
                    </Tooltip>
                  </Col>
                </Row>
                <div className={classes.propertyDetailWrap2}>
                  <div className={classes.propertyDetail}>
                    <Tooltip text={t('propertyCard.tooltips.area') + ` ${areaUnit}`}>
                      <div className={classes.iconContainer}>
                        <img src={upGrid} alt="upGrid" />
                        <p>{m2ToFt2({ area: data?.netArea, areaUnit, unit: false })}</p>
                      </div>
                    </Tooltip>
                  </div>

                  <div className={classes.propertyDetail}>
                    <Tooltip text={t('propertyCard.tooltips.area') + ` (${areaUnit})`}>
                      <div className={classes.iconContainer}>
                        <img src={fullScreen} alt="fullScreen" />
                        <p>
                          {`${m2ToFt2({ area: data?.netArea, areaUnit, unit: false })}${areaUnit}`}
                        </p>
                      </div>
                    </Tooltip>
                  </div>

                  <div className={classes.propertyDetail}>
                    <Tooltip text={t('propertyCard.tooltips.bathrooms')}>
                      <div className={classes.iconContainer}>
                        <img src={bathIcon} alt="bath" />
                        <p>{`${data?.noOfBathrooms}`}</p>
                      </div>
                    </Tooltip>
                  </div>

                  <div className={classes.propertyDetail}>
                    <Tooltip text={t('propertyCard.tooltips.rooms')}>
                      <div className={classes.iconContainer}>
                        <img src={sofa} alt="sofa" />
                        <p>{data?.noOfRooms?.[selectedLanguage]}</p>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
            {type === 'home' ? (
              <div
                className={[classes?.companyLogoCenter].join(' ')}
                onClick={(e) => {
                  e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  navigate(`/company/${data?.company?.slug}`);
                }}>
                <img src={imageUrl(data?.company?.photo)} />
              </div>
            ) : (
              <div className={type === 'map' ? classes.keyMap : classes.key1}>
                {type === 'iconWithImage' && (
                  <div
                    className={classes?.companyLogo}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                      if (!outerNavigate) {
                        navigate(`/company/${data?.company?.slug}`);
                      }
                    }}>
                    <img src={imageUrl(data?.company?.photo)} />
                  </div>
                )}

                {type === 'iconWithImage' && (
                  <div className={classes.priceRow}>
                    <div className={classes.prices}>
                      <p>
                        {usdToOther({ amount: data?.price, ...currency })}
                        {data?.propertyPurpose?.en == 'Rent'
                          ? data?.rentType?.[selectedLanguage]
                          : ''}
                      </p>
                      {/* <p></p> */}
                    </div>
                  </div>
                )}

                {type === 'map' && (
                  <div
                    className={
                      type === 'map' ? classes.socialIconsWrap1Map : classes.socialIconsWrap1
                    }>
                    <a className={classes.socialIcons1} href={`tel:${data?.phoneNumber}`}>
                      <Tooltip text={t('propertyCard.tooltips.call')}>
                        <MdWifiCalling3 fill="#00A997" size={25} />
                      </Tooltip>
                    </a>
                    <div
                      className={[
                        classes.socialIcons1,
                        classes.midIcon,
                        type === 'map' && classes.socialMidIcon
                      ].join(' ')}
                      onClick={(e) => {
                        e.preventDefault();
                        e?.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        onEmailClick && onEmailClick();
                      }}>
                      <Tooltip text={t('propertyCard.tooltips.email')}>
                        <IoIosMail fill="#00A997" size={28} />
                      </Tooltip>
                    </div>
                    <a
                      href={`https://wa.me/${data?.whatsapp}`}
                      target={'_blank'}
                      className={classes.socialIcons1}>
                      <Tooltip text={t('propertyCard.tooltips.whatsapp')}>
                        <IoLogoWhatsapp fill="#00A997" size={25} />
                      </Tooltip>
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>
          {/* </Link> */}{' '}
        </div>
      </div>
    </>
  );
};

export default PropertyCard;
